<template>
  <ComponentCard title="List with pictures" icon="solar:list-heart-minimalistic-linear">
    <BlockField :model-value="attrs.title" placeholder="Title, like In this book" :read-only="readOnly" input-class="font-display text-lg font-bold text-[#1c4848]" @update:model-value="set({ title: $event })" />
    <div v-for="(item, i) in attrs.items" :key="i" class="flex items-start gap-3 rounded-xl bg-[#1c4848]/[0.03] p-2">
      <div class="min-w-0 flex-1">
        <BlockField :model-value="item.title" placeholder="Title" :read-only="readOnly" input-class="text-sm font-bold text-[#1c4848]" @update:model-value="list.patch(i, { title: $event })" />
        <BlockField :model-value="item.text" placeholder="One or two lines" :read-only="readOnly" input-class="text-sm text-[#1c4848]/80" @update:model-value="list.patch(i, { text: $event })" />
        <div v-if="!readOnly" class="flex items-center gap-2 px-2">
          <ImagePicker :context="context" :has-image="Boolean(item.image)" compact @picked="list.patch(i, { image: $event })" />
          <RowActions :first="i === 0" :last="i === attrs.items.length - 1" @up="list.move(i, -1)" @down="list.move(i, 1)" @remove="list.remove(i)" />
        </div>
      </div>
      <img v-if="item.image" :src="item.image" alt="" class="h-20 w-20 shrink-0 rounded-xl object-cover" draggable="false">
    </div>
    <button v-if="!readOnly" type="button" class="min-h-9 rounded-lg px-2 text-xs font-bold text-[#1c4848]/60 hover:bg-[#1c4848]/5 hover:text-[#1c4848]" @click="list.add({ title: '', text: '', image: '' })">+ Add a row</button>
  </ComponentCard>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';
import ImagePicker from '@/components/writer/views/ImagePicker.vue';
import RowActions from '@/components/writer/views/RowActions.vue';
import { useItems } from '@/components/writer/views/useItems.js';

const props = defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
const list = useItems(props);
</script>
